import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { lazy } from "react";
import WithDelay from "./WithDelay";

/* ---------- lazy routes ---------- */
const LandingPage = lazy(() => import("./pages/landing-page/LandingPage"));
const LandingPageKr = lazy(() => import("./pages/landing-page-kr/LandingPageKr"));
const KycModule = lazy(() => import("./pages/kyc-module/KycModule"));
const StrWlfModule = lazy(() => import("./pages/str-wlf-module/StrWlfModule"));
const CtrValidationRbaModule = lazy(() => import("./pages/ctr-validation-rba-module/CtrValidationRbaModule"));
const RbaModule = lazy(() => import("./pages/rba-module/RbaModule"));
const StrCaseInvestigationModule = lazy(() => import("./pages/str-case-investigation-module/StrCaseInvestigationModule"));
const StrRuleManagerCaseMonitoringModule = lazy(() => import("./pages/str-rule-manager-case-monitoring-module/StrRuleManagerCaseMonitoringModule"));
const KycScvModule = lazy(() => import("./pages/kyc-scv-module/KycScvModule"));

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WithDelay><LandingPage /></WithDelay>} />
          <Route path="/landing-page/" element={<WithDelay><LandingPage /></WithDelay>} />
          <Route path="/kr/landing-page/" element={<WithDelay><LandingPageKr /></WithDelay>} />

          <Route path="/str-wlf-module/*" element={<WithDelay><StrWlfModule /></WithDelay>} />
          <Route path="/kyc-module/*" element={<WithDelay><KycModule /></WithDelay>} />
          <Route path="/ctr-validation-rba-module/*" element={<WithDelay><CtrValidationRbaModule /></WithDelay>} />
          <Route path="/rba-module/*" element={<WithDelay><RbaModule /></WithDelay>} />
          <Route path="/str-case-investigation-module/*" element={<WithDelay><StrCaseInvestigationModule /></WithDelay>} />
          <Route path="/str-rule-manager-case-monitoring/*" element={<WithDelay><StrRuleManagerCaseMonitoringModule /></WithDelay>} />
          <Route path="/kyc-scv/*" element={<WithDelay><KycScvModule /></WithDelay>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
